import type { Object3D } from 'three';

const GTAO_OVERLAY_MRT_KEY = '__pmavbdGtaoOverlayMrt';

type OverlayNodeMaterial = {
  userData: Record<string, unknown>;
  mrtNode: unknown;
  needsUpdate: boolean;
};

/**
 * Register a transparent presentation material whose normal output must be
 * suppressed while GTAO's scene MRT is active. The override is deliberately
 * not installed here: native/backbuffer pipeline prewarming has no `normal`
 * attachment and Three r183 would otherwise generate an empty output struct.
 */
export function registerGtaoPresentationOverlayMaterial(
  material: OverlayNodeMaterial,
  overlayMrt: unknown,
): void {
  material.userData[GTAO_OVERLAY_MRT_KEY] = overlayMrt;
  material.mrtNode = null;
}

/** Install or remove the registered MRT override for every overlay material. */
export function setGtaoPresentationOverlayMrt(
  root: Object3D,
  enabled: boolean,
): void {
  root.traverse((object) => {
    const candidate = object as Object3D & {
      material?: OverlayNodeMaterial | OverlayNodeMaterial[];
    };
    const materials = Array.isArray(candidate.material)
      ? candidate.material
      : candidate.material
        ? [candidate.material]
        : [];
    for (const material of materials) {
      const overlayMrt = material.userData?.[GTAO_OVERLAY_MRT_KEY];
      if (overlayMrt === undefined) continue;
      const nextMrt = enabled ? overlayMrt : null;
      if (material.mrtNode === nextMrt) continue;
      material.mrtNode = nextMrt;
      material.needsUpdate = true;
    }
  });
}
